(function(){
  function corners(){
    document.querySelectorAll('.frame').forEach(function(f){
      if(f.dataset.cn) return; f.dataset.cn='1';
      ['tl','tr','bl','br'].forEach(function(p){
        var s=document.createElement('span'); s.className='cn '+p; f.appendChild(s);
      });
    });
  }
  function reveal(){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  }
  function drawer(){
    var d=document.getElementById('drawer'), b=document.getElementById('burger'), x=document.getElementById('x');
    if(b) b.onclick=function(){ d.classList.add('open'); document.body.style.overflow='hidden'; };
    if(x) x.onclick=function(){ d.classList.remove('open'); document.body.style.overflow=''; };
    if(d) d.querySelectorAll('.drawer-nav a').forEach(function(a){
      a.onclick=function(){ d.classList.remove('open'); document.body.style.overflow=''; };
    });
    // Close on ESC
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){ d.classList.remove('open'); document.body.style.overflow=''; }
    });
  }
  document.addEventListener('DOMContentLoaded',function(){ corners(); reveal(); drawer(); });
  document.addEventListener('shopify:section:load',function(){ corners(); reveal(); drawer(); });
})();

/* Quick-add: size picker on product cards */
(function(){
  document.addEventListener('click',function(e){
    var toggle=e.target.closest('.qa-toggle');
    if(toggle){
      e.preventDefault();
      // close other open ones
      document.querySelectorAll('.quick-add.open').forEach(function(q){q.classList.remove('open');});
      toggle.closest('.quick-add').classList.add('open');
      return;
    }
    if(e.target.closest('.qa-close')){
      e.preventDefault();
      e.target.closest('.quick-add').classList.remove('open');
      return;
    }
    // click outside closes
    if(!e.target.closest('.quick-add')){
      document.querySelectorAll('.quick-add.open').forEach(function(q){q.classList.remove('open');});
    }
  });
})();
